module.exports = __webpack_public_path__ + "img/exam-result-public.a8200a6a.svg";